import { create } from 'zustand'
import { CHIP_VALUE_ARR } from '../types/Config'


const genPath = (v: number) => `./assets/images/chips/${v}.png`

type Chip = {
  index: number,
  price: number,
  path: string
}

type ChipStore = {
  chips: Chip[]
  selectedChip: Chip
  selectChip: (index: number) => void
}

export const useChipStore = create<ChipStore>((set, get) => ({
  chips: CHIP_VALUE_ARR.map((price, index) => {
    const path = genPath(price);
    return { index, price, path }
  }),
  selectedChip: {} as Chip,

  selectChip: (index: number) => {
    const chips = get().chips;
    const selectedChip = get().selectedChip;
    if (index !== selectedChip.index) {
      set({ selectedChip: chips[index] })
    }
  },
}))